<script setup>
const GRID_TYPES = { grid: "grid", flex: "flex" };

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "grid",
    validator: function (value) {
      // The value must match one of these strings
      return (
        Object.values({ grid: "grid", flex: "flex" }).indexOf(value) !== -1
      );
    },
  },
  cols: {
    type: Number,
    default: 2,
  },
  size: {
    type: String,
    default: "",
  },
  wrap: {
    type: String,
    default: "wrap",
    validator: function (value) {
      // The value must match one of these strings
      return ["wrap", "nowrap"].indexOf(value) !== -1;
    },
  },
  isMultiple: {
    type: Boolean,
    default: true,
  },
  selected: {
    type: String || Number || Object || Array || null,
    default: null,
  },
});

const emit = defineEmits(["r:change"]);

const _selected = ref([]);
if (!props.isMultiple) {
  _selected.value = [props.options[0]];
}

if (props.selected) {
  if (Array.isArray(props.selected)) {
    _selected.value = [...props.selected];
  } else {
    _selected.value = [props.selected];
  }
}

function onOptionClick(option) {
  if (props.isMultiple) {
    if (_selected.value.indexOf(option) === -1) {
      _selected.value.push(option);
    } else {
      _selected.value.splice(_selected.value.indexOf(option), 1);
    }
    emit("r:change", _selected.value);
  } else {
    if (_selected.value.indexOf(option) === -1) {
      _selected.value = [option];
    }
    emit("r:change", option);
  }
}

const showAll = ref(false);

const optionsToShow = computed(() => {
  if (!showAll.value) return props.options.slice(0, 6);
  return props.options;
});
</script>

<template>
  <div>
    <h6
      v-if="title"
      class="font-sans text-lg text-dark-gray font-semibold mb-3 leading-none w-full"
    >
      {{ title }}
    </h6>
    <div
      :class="[
        type === GRID_TYPES.grid
          ? `grid grid-flow-row grid-cols-${cols} gap-x-7 gap-y-5 w-full`
          : type === GRID_TYPES.flex
          ? 'flex flex-row flex-wrap gap-x-7 gap-y-5'
          : '',
      ]"
    >
      <r-button
        v-for="option in optionsToShow"
        :key="option"
        size="lg"
        :class="[size.length ? size : '']"
        :textColor="_selected.indexOf(option) !== -1 ? 'white' : 'dark-gray'"
        :default-color="_selected.indexOf(option) !== -1 ? 'primary' : 'nude'"
        cursor="pointer"
        @r:click="onOptionClick(option)"
        >{{ option }}</r-button
      >

      <r-button
        v-if="!showAll && options.length > 6"
        size="lg"
        :textColor="'white'"
        :default-color="'dark-gray'"
        cursor="pointer"
        @r:click="showAll = true"
        >...</r-button
      >
    </div>
  </div>
</template>
